import React from 'react';

export default function JobPropertyInfo({ job }) {
  // Helper to format currency
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return 'N/A';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <div className="bg-white shadow rounded-lg mb-3 lg:mb-6">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4 flex items-center">
          Property Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Property Address and Map Links - Column 1 */}
          <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
            <h4 className="text-base font-medium text-gray-900 mb-2">
              Property Address
            </h4>
            <p className="text-base text-gray-900 mb-4">
              {job.property.address}<br />
              {job.property.city}, {job.property.state} {job.property.zip}
            </p>
            
            {/* Map Direction Buttons */}
            <div>
              <p className="text-sm font-medium text-gray-700 mb-2">Directions</p>
              <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
                <a
                  href={`https://maps.apple.com/?q=${encodeURIComponent(
                    `${job.property.address}, ${job.property.city}, ${job.property.state} ${job.property.zip}`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <svg className="mr-2 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                  </svg>
                  Apple Maps
                </a>
                <a
                  href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
                    `${job.property.address}, ${job.property.city}, ${job.property.state} ${job.property.zip}`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <svg className="mr-2 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Google Maps
                </a>
              </div>
            </div>
          </div>
          
          {/* Property Access Information - Column 2 */}
          <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
            <h4 className="text-base font-medium text-gray-900 mb-2">
              Access Details
            </h4>
            {/*<div>
              <p className="text-sm font-medium text-gray-700">Property Code</p>
              <p className="text-base text-gray-900 mb-2">{job.property.propertyCode || 'N/A'}</p>
            </div>*/}

            {job.property.entryDetails && (
              <div className="mt-2">
                <p className="text-sm font-medium text-gray-700">Entry Details</p>
                <p className="text-base text-gray-900 mt-1 whitespace-pre-line">{job.property.entryDetails}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
